// Baja al disco el CSV que el `run` ya devolvió. El silo genera el archivo dentro de la misma
// llamada; sin esto la respuesta se descarta y el operador tiene que volver a pedir la corrida.
import type { ReportRunResult } from '@/api/services/retail-wizard/backoffice';

/**
 * Entrega el archivo al navegador. Devuelve `false` cuando la corrida no produjo nada que bajar
 * — un `201` con `status: FAILED` es posible, y ofrecer una descarga vacía sería peor que avisar.
 */
export function downloadReportFile(result: ReportRunResult): boolean {
    if (result.status !== 'READY') return false;

    const blob = new Blob([result.content], { type: result.contentType });
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = result.filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    // El revoke va DIFERIDO: Firefox y Safari cancelan la descarga en silencio si el blob se libera
    // antes de que el navegador termine de leerlo.
    setTimeout(() => {
        URL.revokeObjectURL(objectUrl);
    }, 0);
    return true;
}
